import React from "react";
import { Message, type MessageType } from "components/Atoms/Message";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const SaveByPayingPerYear = (props: Props) => {
  const types: MessageType[] = ["error", "success", "info", "accent"];

  if (props.nextSubscriptionType.value !== "paid" || props.activeSubscription.billingCycle !== "monthly" || props.nextBillingCycle.value !== "monthly") {
    return <></>;
  }

  const randomType = types[Math.floor(Math.random() * types.length)];

  return <div className="margin-top-large">
    <Message type={randomType} style={{ textAlign: "center" }}>
      <div className="margin-bottom-small"><strong>{RESX.Subscription.SaveByPayingPerYear}</strong></div>
      <div>{RESX.Subscription.ContactUsToChangeBillingCycle}</div>
    </Message>
  </div>;
};

export default SaveByPayingPerYear;
